export declare type Role =
  | 'ADMINISTRATOR'
  | 'EVALUATOR'
  | 'OWNER'
  | 'SCHOLAR';
